{
  "title": "Locataires",
  "subtitle": "Toutes les organisations clientes de la plateforme",
  "subtitlePartnerView": "Clients attribués à ce partenaire",
  "addTenant": "Ajouter un locataire",
  "onlyMspCanAdd": "Seuls les administrateurs MSP peuvent ajouter des locataires",
  "cannotAddTenant": "Il faut un accès administrateur MSP ou partenaire pour ajouter un locataire",
  "loadError": "Impossible de charger les locataires",
  "emptyTitle": "Aucun locataire pour l’instant",
  "emptyDescription": "Un locataire est une organisation cliente. En en ajoutant un, vous lancez l’assistant d’intégration : consentement, connecteurs, groupe pilote et validation avant toute modification de leur messagerie.",
  "emptyTitlePartnerView": "Aucun client pour ce partenaire pour l’instant",
  "emptyDescriptionPartnerView": "Ajoutez un client pour lancer son intégration. Les locataires créés ici sont automatiquement attribués à ce partenaire.",
  "colTenant": "Locataire",
  "colOnboarding": "Intégration",
  "colStamping": "Estampillage",
  "colDomains": "Domaines",
  "colSnapshot": "Instantané",
  "noneSynced": "aucun synchronisé",
  "orgName": "Nom de l’organisation",
  "orgNamePlaceholder": "Contoso SARL",
  "slug": "Identifiant",
  "slugDescription": "En minuscules ; utilisé dans les URL et dans le sujet du certificat du locataire. Non modifiable une fois l’intégration commencée.",
  "slugError": "Uniquement lettres minuscules, chiffres et tirets.",
  "createError": "Impossible de créer le locataire",
  "onboardingStateCreated": "Créé",
  "onboardingStateConsented": "Consentement donné",
  "onboardingStateConnectors": "Connecteurs créés",
  "onboardingStatePilot": "Pilote",
  "onboardingStateValidated": "Validé",
  "onboardingStateOrgWide": "Toute l’organisation",
  "onboardingStateOffboarding": "Désactivation",
  "stampingActive": "Actif",
  "stampingActivePilot": "Actif (pilote)",
  "stampingBypassed": "Contourné",
  "stampingBypassedAuto": "Contourné (automatique)",
  "noReasonRecorded": "Aucun motif enregistré",
  "overview": "Vue d’ensemble",
  "defaultFieldsTitle": "Champs par défaut",
  "defaultFieldsHint": "Ces valeurs remplissent les champs d’annuaire vides pour tout le monde. Les remplissages de groupe l’emportent pour les membres ; une surcharge personnelle l’emporte toujours.",
  "defaultFieldsSaved": "Champs par défaut enregistrés.",
  "tabSettings": "Paramètres",
  "tabBilling": "Facturation",
  "tabAccess": "Accès",
  "tabDirectory": "Annuaire",
  "loadTenantError": "Impossible de charger le locataire",
  "deleteTenant": "Supprimer le locataire",
  "deleteConfirmTitle": "Supprimer ce locataire ?",
  "deleteConfirmBody": "Cela retire {{name}} des listes et de l’estampillage. La ligne est conservée pour l’audit et l’historique de facturation.",
  "partner": "Partenaire",
  "noPartner": "Aucun partenaire",
  "stampingMode": "Mode d’estampillage",
  "bypassReason": "Motif du contournement",
  "setActive": "Activer",
  "setBypass": "Contourner l’estampillage",
  "smartHost": "Smart host",
  "verifiedDomains": "Domaines vérifiés",
  "snapshotVersion": "Version d’instantané",
  "noAccessPartners": "Pas d’accès aux partenaires",
  "noAccessPartnersBody": "Les accords revendeurs sont gérés par l’équipe OnBrand Mail.",
  "tabSignatures": "Signatures",
  "tabRules": "Règles",
  "tabCampaigns": "Campagnes",
  "tabUsers": "Utilisateurs",
  "tenantNotFound": "Locataire introuvable",
  "tenantNotFoundBody": "Ce locataire n'existe pas, ou vous n'y avez pas accès.",
  "openDesigner": "Ouvrir le concepteur",
  "loadTemplatesError": "Impossible de charger les modèles",
  "noTemplatesTitle": "Aucun modèle pour l'instant",
  "noTemplatesDescription": "Concevez, publiez et organisez des modèles de signature pour ce locataire. Tout commence dans le concepteur.",
  "templatesAssignableHint": "Modèles que les règles de ce locataire peuvent attribuer.",
  "renderingSignaturesTitle": "Rendu des signatures",
  "renderingSignaturesBody": "Une publication ou un changement de règle est en cours d'application aux boîtes de ce locataire. Tant que ce n'est pas terminé, les expéditeurs conservent la signature qu'ils avaient déjà.",
  "lastRenderFailed": "Le dernier rendu a échoué",
  "retriedTimes": "Réessayé {{count}} fois.",
  "publishedDate": "publié le {{date}}",
  "neverPublished": "jamais publié",
  "templateStatusDraft": "Brouillon",
  "templateStatusPublished": "Publié",
  "templateStatusArchived": "Archivé",
  "openRulesEditor": "Ouvrir l'éditeur de règles",
  "loadRulesError": "Impossible de charger les règles",
  "noRulesTitle": "Aucune règle pour l'instant",
  "noRulesDescription": "Sans valeur par défaut ni règle, rien n'est estampillé. Définissez une signature par défaut dans Utilisateurs, ou ouvrez l'éditeur de règles pour ajouter une règle plus précise.",
  "rulesEvalHint": "Évaluées de haut en bas ; la première correspondance l'emporte.",
  "matchesNobody": "Ne correspond à personne",
  "matchesNobodyTooltip": "Une portée d'expéditeurs vide ne correspond à personne, donc cette règle ne se déclenche jamais.",
  "newWithTemplate": "Nouveau : {{name}}",
  "newNoTemplate": "Nouveau : aucun modèle",
  "replyWithTemplate": "Réponse : {{name}}",
  "replySameAsNew": "Réponse : identique au nouveau",
  "primaryDefault": "Valeur par défaut principale",
  "defaultBadge": "Par défaut",
  "everyone": "Tout le monde",
  "stampingStoppedAutoTitle": "L'estampillage s'est arrêté tout seul",
  "stampingBypassedTitle": "L'estampillage est contourné",
  "stampingStoppedAutoBody": "Un nœud de flux de messagerie a arrêté d'estampiller ce locataire après des échecs répétés, à {{when}}. Personne ne l'a désactivé. Le courrier circule sans estampillage.",
  "stampingBypassedBody": "Le courrier de ce locataire est relayé sans modification.",
  "stampingModeHint": "Le contournement relaie le courrier de ce locataire intact tout en gardant OnBrand Mail sur le chemin. Utilisez-le lorsque les signatures sont incorrectes ou que le rendu échoue — pas lorsque le courrier ne peut pas circuler.",
  "resumeStamping": "Reprendre l'estampillage",
  "stampingModePermission": "Les administrateurs du locataire et au-dessus peuvent modifier le mode d'estampillage.",
  "operations": "Opérations",
  "operationsHint": "Connectez l'annuaire du client, générez les connecteurs Exchange et vérifiez le chemin de messagerie ici. Le testeur de configuration vérifie le DNS, le TLS et le relais avant d'acheminer le courrier via la plateforme.",
  "onboardingWizard": "Assistant d'intégration",
  "configurationTester": "Testeur de configuration",
  "mspOperations": "Opérations MSP",
  "mspOperationsHint": "Les incréments d'instantané forcent les nœuds de flux à recharger règles et modèles. La rotation du secret d'estampillage invalide le précédent — mettez à jour la règle de transport du locataire avant la reprise du courrier.",
  "bumpSnapshot": "Incrémenter l'instantané",
  "snapshotBumped": "Instantané incrémenté à v{{version}}.",
  "bumpFailed": "L'incrément a échoué.",
  "rotateStampingSecret": "Faire tourner le secret d'estampillage",
  "deleteTenantHint": "Retire cette organisation de la plateforme. L'estampillage s'arrête immédiatement et le locataire disparaît de toutes les listes. Retirez d'abord les connecteurs Exchange et les règles de transport si le courrier passe encore par OnBrand Mail — la suppression ne les démonte pas.",
  "bypassPlaceholder": "INC-4711 échec de rendu, contourné en attente d'investigation",
  "resumePlaceholder": "INC-4711 résolu ; reprise après canari réussi",
  "signatureRendering": "Rendu des signatures",
  "signatureRenderingHint": "Les signatures sont rendues par boîte à l'avance, de sorte qu'estampiller un message est une recherche plutôt qu'un rendu. Publier un modèle ou modifier une règle met cela en file automatiquement.",
  "renderingNow": "Rendu en cours",
  "queued": "En file",
  "lastCompletedAt": "Dernière fin {{when}}",
  "nothingRenderedYet": "Rien n'a encore été rendu",
  "rerenderQueued": "Nouveau rendu mis en file. Les signatures se mettent à jour en quelques secondes.",
  "rerenderFailed": "Impossible de mettre un nouveau rendu en file.",
  "rerenderSignatures": "Rendre à nouveau les signatures",
  "rerenderPermission": "Les administrateurs du locataire et au-dessus peuvent forcer un nouveau rendu.",
  "stampingBypassedToast": "Estampillage contourné. Le courrier est relayé sans modification.",
  "stampingResumedToast": "Estampillage repris.",
  "reasonRequiredHint": "Un motif est requis. Il s'affiche sur le locataire et est consulté lors des incidents.",
  "updateStampingError": "Impossible de mettre à jour le mode d'estampillage",
  "bypassConfirm": "Contourner",
  "resumeConfirm": "Reprendre",
  "copySecretNowTitle": "Copiez ceci maintenant",
  "copySecretNowBody": "Le secret n'est affiché qu'une fois. Seul son hash est stocké. Collez-le dans la règle de transport du locataire avant que le courrier ne soit à nouveau attribué.",
  "copySecretButton": "Copier le secret",
  "rotateConfirmHint": "La rotation invalide immédiatement le secret précédent. Tapez {{word}} pour confirmer.",
  "confirmation": "Confirmation",
  "rotateSecretError": "Impossible de faire tourner le secret",
  "deleteCannotUndo": "Ceci ne peut pas être annulé depuis le portail",
  "deleteWarningBody": "{{name}} ({{slug}}) quittera toutes les listes de locataires et ne sera plus estampillé. Les connecteurs Exchange et les règles de transport ne sont pas retirés automatiquement.",
  "typeSlugToConfirm": "Tapez {{slug}} pour confirmer",
  "deleteTenantError": "Impossible de supprimer le locataire",
  "tenantDeleted": "{{name}} a été supprimé.",
  "noRoleBody": "Vous n'avez pas de rôle sur ce locataire.",
  "readOnlyTitle": "Lecture seule",
  "noAccessTenantTitle": "Pas d'accès à ce locataire",
  "noAccessRulesTitle": "Pas d'accès à ces règles",
  "readOnlyRulesBody": "Vous pouvez voir les règles et lancer le testeur, mais les modifier nécessite le rôle Éditeur.",
  "noAccessDesignerTitle": "Pas d'accès à ce concepteur",
  "noAccessDesignerBody": "Vous avez besoin du rôle Concepteur ou supérieur sur ce locataire pour modifier ses modèles de signature.",
  "noAccessUsersTitle": "Pas d'accès à ces utilisateurs",
  "readOnlyUsersBody": "Vous pouvez voir les boîtes et signatures, mais les exceptions nécessitent le rôle Administrateur du locataire.",
  "noAccessGroupsTitle": "Pas d'accès à ces groupes",
  "readOnlyGroupsBody": "Vous pouvez voir les groupes synchronisés, mais les exceptions nécessitent le rôle Administrateur du locataire.",
  "noAccessCampaignsTitle": "Pas d'accès à ces campagnes",
  "readOnlyCampaignsBody": "Vous pouvez voir les campagnes, mais les créer ou les modifier nécessite le rôle Éditeur."
}
